import { formatCurrency } from "@/utils/currencyFormatter";

/**
 * Formats bus prices with currency-specific rules.
 * - TRY/SAR uses currency code (TL/SAR) instead of symbol.
 * - Other currencies show symbol when available.
 * - Preserves decimals only when needed; no rounding by default.
 *
 * @param {number} price
 * @param {string} currencyCode
 * @returns {string}
 */
export const formatBusPrice = (price, currencyCode = "TRY", customDecimalsControls = false) => {
  if (!price && price !== 0) {
    if (currencyCode === "TRY") return "0 TL";
    if (currencyCode === "SAR") return "0 SAR";
    return `0 ${currencyCode}`;
  }

  /* eski kural listede TL de kusurat gozukmemesi için özel kural. TL de kusurat yok ama diğer para birimlerinde kusurat gozukecek
    let hasDecimals = price % 1 !== 0; // gelen değer kusuratlı ise true, kusuratsız ise false ona gore decimals değeri değişiyor

    if (customDecimalsControls){

      if (currencyCode === "TRY"){
        hasDecimals = false;
      }else{
        hasDecimals = true;
      }

    }

  */

  // yeni kural listede hiç bir para biriminde kusurat gosterme
  let hasDecimals = true;
  if (customDecimalsControls){
    hasDecimals = false;
  }

  const useCode = currencyCode === "TRY" || currencyCode === "SAR";

  return formatCurrency(price, currencyCode, {
    showSymbol: !useCode,
    showCode: useCode,
    decimals: hasDecimals ? 2 : 0,
    round: false,
  });
};

